import { createContext } from "react";

const UserContext = createContext();
UserContext.displayName = "User";
export default UserContext;
